<template>
  <div>
    <b-card style="border: none; margin-left: 2rem; margin-right: 2rem">
      <!--b-row>
        <b-col md="2" class="my-auto">
          <span>Direktannahme: </span>
        </b-col>
        <b-col md="6">
          <b-form-group >
            <b-form-radio-group
                v-model="acceptTask"
                :options="acceptTaskOptions"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="height: 1px; background: #bdbdbd"></b-row-->
      <b-row>
        <!--div v-if="!acceptTask" style="width: 100%; height: 100%; position: absolute; background: rgba(101,101,101,0.28); z-index: 100;"></div-->
        <b-col class="mt-3">
          <b-row>
            <b-col md="4" class="my-auto">
              <span>Leistungsgruppe:</span>
            </b-col>
            <b-col>
              <b-input-group>
                <template #append>
                  <edit-icon @click="$refs.select_legr.showDialog(legrs)" title="" v-tooltip="'Anpassen'"
                             class="icon-1_5x" fillColor="#2463ea"
                             style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;"
                             :size="72"></edit-icon>
                </template>
                <b-form-input class="form-control text-black"
                              :style="selectedLegr.name !== null && selectedLegr.name !== '' ? '' : 'border-color: red'"
                              v-model="selectedLegr.name"
                              disabled
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="mt-3 mb-1">
            <b-col>
              <span>Verantwortlich / Abrechnend:</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <v-jstree ref="js_tree" :allow-transition="false"
                        :style="selectedKostMigr === null ? 'flex: 1 0; border: 1px solid red; border-radius: 0.25rem;' :'flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem;'"
                        class="my-tree" :data="kostMigrs"
                        @item-click="onItemClicked"
                        show-checkbox></v-jstree>
            </b-col>
          </b-row>

        </b-col>
        <b-col class="mt-3" style="padding-left: 10px;">
          <b-row>
            <b-col md="4" class="my-auto">
              <span>Zieldatum:</span>
            </b-col>
            <b-col>
              <datetime
                  v-model="dueDate"
                  input-class="form-control mb-2"
                  :input-style="dueDate === null || dueDate === '' ? 'border-color: red;' : 'color: black;'"

                  input-id="date"
                  :phrases="datetimeConfig.phrases"
                  :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                  :min-datetime="datetimeConfig.minTime"></datetime>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="4" class="my-auto">
              <span>Fertigstellungsart</span>
            </b-col>
            <b-col>
              <b-form-select :options="close_automatic_select" id="close_automatic" :plain="true"
                             v-model="close_automatic"
                             class="mb-2 text-black"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="hasTaskSeries">
            <b-col md="4" class="my-auto">
              <b-form-checkbox switch v-model="task_series_enabled">
                Serienaufgabe
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-input-group>
                <template #append v-if="task_series_enabled">
                  <edit-icon @click="$refs.create_task_series_dialog.showModal(users)" title="" v-tooltip="'Anpassen'"
                             class="icon-1_5x" fillColor="#2463ea"
                             style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;"
                             :size="72"></edit-icon>
                </template>
                <b-form-input class="form-control text-black"
                              v-model="taskSeriesTitle"
                              disabled
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="mt-2" style="padding-top: 5px">
            <b-col md="4" class="my-auto">
              <span style="margin-top: 4px">Versandart</span>
              <p style="font-size: 12px; color: dimgrey; margin: 0">Gibt an wann die Aufgaben, in relation zum Zieldatum, an das mobile Gerät übertragen werden.</p>
            </b-col>
            <b-col v-if="taskSendType !== 'S'" md="2">
              <b-form-input class="form-control text-black"
                            v-model="taskSendInterval"
                            type="number"
                            min="1"
                            step="1"
                            @keydown="preventDecimals"
              ></b-form-input>
            </b-col>
            <b-col>
              <b-form-select :options="taskSendTypes" :plain="true"
                             v-model="taskSendType"
                             class="mb-2 text-black"></b-form-select>
            </b-col>
          </b-row>
          <b-row style="margin-top: 5px">
            <b-col md="8" class="my-auto">
              <span><strong>Ausführend: Mitarbeiter / Gruppen</strong></span>
            </b-col>
            <b-col md="4">
              <b-row style="flex-direction: row-reverse; margin-right: 8px">
                <!--pencil-plus-icon title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style=" cursor: pointer; color: #016d03; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$refs.change_todo.showDialog(currentPlanning)"></pencil-plus-icon>
                <minus-icon title="" v-tooltip="'Entfernen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="onDeletePlanning"></minus-icon>
                <plus-icon title="" v-tooltip="'Hinzufügen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$refs.select_plannings.showDialog(users)"></plus-icon-->
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm" @click="showTodoDialog">
                  Verteilung anpassen
                </b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-table striped hover selectable :items="selectedPlannings" :fields="planningFields"
                       select-mode="single"
                       selectedVariant="primary"
                       ref="group_table"
                       @row-selected="onRowSelected"
              >
                <template v-slot:cell(message)="data">
                  <div style="display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;">{{ data.item.memo }}
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <select-legr-dialog ref="select_legr" @legr-selected="onLegrChanged"></select-legr-dialog>
    <select-planning-dialog ref="select_plannings" @planning-selected="onNewPlanning"></select-planning-dialog>
    <change-todo-dialog ref="change_todo"
                        @change-todo="(todo) => {$refs.update_todos_dialog.onChangeTodo(todo)}"></change-todo-dialog>
    <update-todos-dialog ref="update_todos_dialog"
                         @change-todo="(currentPlanning) => {$refs.change_todo.showDialog(currentPlanning)}"
                         @todos-updated="onTodosUpdated"/>
    <create-task-series-dialog ref="create_task_series_dialog" :task-date="dueDate"
                               @create-task-series="createTaskSeries"/>

  </div>
</template>

<script>
import {arrayContains, Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
import EditIcon from 'vue-material-design-icons/PencilCircle.vue';
import PencilPlusIcon from "vue-material-design-icons/PencilPlus.vue";
import PlusIcon from "vue-material-design-icons/PlusCircle.vue";
import MinusIcon from "vue-material-design-icons/MinusCircle.vue";
import VJstree from "vue-jstree";
import SelectLegrDialog from "../../aufgaben_verwaltung/SelectLegrDialog.vue"
import SelectPlanningDialog from "../../aufgaben_verwaltung/SelectPlanningDialog.vue"
import ChangeTodoDialog from "../../aufgaben_verwaltung/ChangeTodoDialog.vue"
import UpdateTodosDialog from "@/views/aufgaben_verwaltung/UpdateTodosDialog.vue";
import {v4, v4 as uuidv4} from 'uuid';
import {DateTime as LuxonDateTime} from 'luxon'
import {parseTimestamp} from "@/shared/dates";
import CreateTaskSeriesDialog from "@/views/aufgaben_verwaltung/CreateTaskSeriesDialog.vue";


export default {
  name: "task_step_plan_task",
  props: ['currentStep', 'isVisible'],
  components: {
    EditIcon,
    PencilPlusIcon,
    PlusIcon,
    MinusIcon,
    VJstree,
    SelectLegrDialog,
    SelectPlanningDialog,
    ChangeTodoDialog,
    UpdateTodosDialog,
    CreateTaskSeriesDialog
  },
  mounted() {
    this.$emit('can-continue', {value: false});
    this.legrs = this.currentStep.payload.legrs;
    this.kostMigrs = this.computeKostMigrs(this.currentStep.payload.bhStructure);
    this.users = this.currentStep.payload.bhStructure;
    this.dueDate = this.currentStep.payload.dueDate;
    this.taskMemo = this.currentStep.payload.taskMemo;
    this.taskSubject = this.currentStep.payload.taskSubject;
    this.computeMitas(this.users);
    let modules = sessionStorage.getItem("suite_modules");
    if (modules !== null && modules !== "") {
      modules = JSON.parse(modules);
      if (arrayContains(modules, 24)) {
        this.hasTaskSeries = true;
      }
    }
    let taskSendType = this.$cookies.get("task_send_type");
    if (taskSendType) {
      this.taskSendType = taskSendType;
    }
    if (this.taskSendType !== "S") {
      let taskSendInterval = this.$cookies.get("task_send_interval");
      if (taskSendInterval) {
        this.taskSendInterval = taskSendInterval;
      }
    }
  },
  data() {
    return {
      loader: undefined,
      legrs: [],
      kostMigrs: [],
      users: [],
      acceptTaskOptions: [{text: "als Aufgabe", value: 'Aufgabe'}, {text: "als Einzelauftrag", value: 'Auftrag'}], //, {text: "Nein", value: ''}
      acceptTask: 'Aufgabe',
      selectedLegr: {name: ""},
      selectedKostMigr: null,
      //planningFields: [{key: "name", label: 'Name'}, {key: "till", label: "Ziel", formatter: 'formateDueDate'}, {key: "message",label: "Aufagbentext"}],
      planningFields: [{key: "name", label: 'Name'}, {
        key: "dueDate",
        label: "Ziel",
        formatter: 'formateDueDate'
      }, {key: "memo", label: "Aufgabentext"}],
      selectedPlannings: [],
      dueDate: null,
      taskMemo: "",
      taskSubject: "",
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      currentPlanning: null,
      close_automatic: false,
      close_automatic_select: [{text: "Manuelle Fertigstellung", value: false}, {
        text: "Automatische Fertigstellung",
        value: true
      }],
      bhStructure: [],
      task_series: null,
      task_series_enabled: false,
      hasTaskSeries: false,
      taskSendInterval: "2",
      taskSendType: "S",
      taskSendTypes: [
          {text: "Sofort", value: "S"}, {text: "Tage vorher", value: "D"}, {text: "Wochen vorher", value: "W"}],
    }
  },
  computed: {
    taskSeriesTitle() {
      if (!this.task_series) {
        return this.task_series_enabled ? "Bitte definieren ->" : "Keine Wiederholung"
      } else {
        switch (this.task_series.series_type) {
          case "Y":
            return "Jährliche Wiederholung";
          case "M":
            return "Monatliche Wiederholung";
          case "W":
            return "Wöchentliche Wiederholung";
        }
      }
      return "";
    },
  },
  watch: {
    task_series_enabled(n, o) {
      if (!n) {
        this.task_series = null;
      } else {
        this.$refs.create_task_series_dialog.showModal(this.users);
      }
    },
    selectedLegr(n, o) {
      if (n.name !== "" && this.selectedKostMigr && this.dueDate) {
        this.$emit('can-continue', {value: true});
        return;
      }
      this.$emit('can-continue', {value: false});
    },
    selectedKostMigr(n, o) {
      if (this.selectedLegr.name !== "" && n && this.dueDate) {
        this.$emit('can-continue', {value: true});
        return;
      }
      this.$emit('can-continue', {value: false});
    },
    dueDate(n, o) {
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (!this.selectedPlannings[i].dueDate) {
          this.selectedPlannings[i].dueDate = n;
        }
      }
      if (this.selectedLegr.name !== "" && this.selectedKostMigr && n) {
        this.$emit('can-continue', {value: true});
        return;
      }
      //}
      this.$emit('can-continue', {value: false});
    },
  },
  methods: {
    createTaskSeries(payload) {
      this.task_series = payload;
    },
    preventDecimals(evt) {
      if (['.', 'e', 'E', '+', '-'].includes(evt.key) || (this.taskSendInterval === "" && evt.key === "0")) {
        evt.preventDefault();
      }
    },
    showTodoDialog() {
      let todos = [];
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        todos.push({
          id: this.selectedPlannings[i]._id,
          user_id: this.selectedPlannings[i].id,
          till: this.selectedPlannings[i].dueDate,
          message: this.selectedPlannings[i].memo,
          name: this.selectedPlannings[i].name,
        })
      }
      this.$refs.update_todos_dialog.showDialog(this.users, todos, this.taskMemo, "dummy", this.taskSubject, this.dueDate ? this.dueDate : LuxonDateTime.local())
    },
    onTodosUpdated(res) {
      this.selectedPlannings = [];
      for (let i = 0; i < res.todos.length; i++) {
        this.selectedPlannings.push({
          id: res.todos[i].user_id,
          _id: res.todos[i].id,
          memo: res.todos[i].message,
          dueDate: res.todos[i].till,
          name: res.todos[i].name,
        })
      }
    },
    setActive: function (payload) {
      if (payload.dueDate !== this.dueDate) {
        this.dueDate = payload.dueDate;
        for (let i = 0; i < this.selectedPlannings.length; i++) {
          this.selectedPlannings[i].dueDate = this.dueDate;
        }
      }
      if (payload.taskMemo !== this.taskMemo) {
        this.taskMemo = payload.taskMemo;
        for (let i = 0; i < this.selectedPlannings.length; i++) {
          this.selectedPlannings[i].memo = this.taskMemo;
        }
      }
      if (this.$emit) {
        if (this.selectedLegr.name !== "" && this.selectedKostMigr && this.dueDate) {
          this.$emit('can-continue', {value: true});
          return;
        }
        this.$emit('can-continue', {value: false});
      }
    },
    getReturnData: function () {
      this.$cookies.set("task_send_type", this.taskSendType);
      if (this.taskSendType !== "S" && this.taskSendInterval !== "") {
        this.$cookies.set("task_send_interval", this.taskSendInterval);
      }
      return {
        selected_legr: this.selectedLegr,
        selected_kost_migr: this.selectedKostMigr,
        dueDate: this.dueDate,
        //acceptTask: this.acceptTask,
        todos: this.selectedPlannings,
        close_automatic: this.close_automatic,
        task_series: this.task_series,
        task_send_type: this.taskSendType,
        task_send_interval: this.taskSendInterval,
      };
    },
    formateDueDate(value) {
      if (!value) {
        return ""
      } else {
        return parseTimestamp(new Date(Date.parse(value)), 'DD.MM.YYYY');
      }
    },
    onRowSelected(data) {
      if (data.length) {
        this.currentPlanning = data[0];
      } else {
        this.currentPlanning = null;
      }
    },
    onLegrChanged(data) {
      this.selectedLegr = data.selected_legr;
    },
    onItemClicked(node, item, e) {
      this.selectedKostMigr = item;
    },
    computeKostMigrs(data) {
      data.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    onNewPlanning(selected) {
      for (let i = 0; i < selected.length; i++) {
        let cur = selected[i];
        cur._id = v4();
        cur.memo = this.taskMemo;
        cur.dueDate = this.dueDate;
        this.selectedPlannings.push(cur);
      }
    },
    onDeletePlanning() {
      if (!this.currentPlanning) {
        return;
      }
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (this.selectedPlannings[i]._id === this.currentPlanning._id) {
          this.selectedPlannings.splice(i, 1);
        }
      }
      this.currentPlanning = null;
    },
    onChangeTodo(data) {
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (this.selectedPlannings[i]._id === data._id) {
          this.selectedPlannings[i] = data;
          this.selectedPlannings = [...this.selectedPlannings]
        }
      }
      this.currentPlanning = null;
    }
  }
}
</script>

<style scoped>

</style>
